
import React from 'react';
import { useCurrentSubscription } from '@/hooks/useCurrentSubscription';
import SubscriptionLoading from '@/components/subscription/SubscriptionLoading';
import SubscriptionError from '@/components/subscription/SubscriptionError';
import ActiveSubscription from '@/components/subscription/ActiveSubscription';
import FreemiumSubscription from '@/components/subscription/FreemiumSubscription';
import { useAuth } from '@/hooks/useAuth';

/**
 * Hook personnalisé qui détermine le composant d'abonnement à afficher
 * en fonction de l'état actuel de l'utilisateur et de son abonnement.
 */
export const useSubscriptionStatusComponent = () => {
  const { userProfile } = useAuth();
  const { data: subscription, isLoading, error } = useCurrentSubscription();
  
  // Vérifier si l'utilisateur a un compte freemium
  const isFreemium = userProfile?.niveau_compte_id === 1;
  
  // Retourner le composant approprié en fonction de l'état
  if (isLoading) {
    return <SubscriptionLoading />;
  }

  if (isFreemium) {
    return <FreemiumSubscription subscription={null} />;
  }

  if (error) {
    return <SubscriptionError />;
  }

  if (subscription && subscription.status === 'active') {
    return <ActiveSubscription subscription={subscription} />;
  }

  // Fallback pour tous les autres cas
  return <FreemiumSubscription subscription={subscription} />;
};
